import { render, staticRenderFns } from "./AlternativeTextPage.vue?vue&type=template&id=3729eef0&scoped=true"
import script from "./AlternativeTextPage.vue?vue&type=script&lang=js"
export * from "./AlternativeTextPage.vue?vue&type=script&lang=js"
import style0 from "./AlternativeTextPage.vue?vue&type=style&index=0&id=3729eef0&prod&lang=css"
import style1 from "./AlternativeTextPage.vue?vue&type=style&index=1&id=3729eef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3729eef0",
  null
  
)

export default component.exports